export function FormatSize(size: number | undefined): string {
    if (size === undefined || size == 0) {
        return "1 KB";
    } else if (size < Math.pow(2, 10)) {
        return size.toString() + " B";
    } else if (size < Math.pow(2, 20)) {
        return Math.round(size / Math.pow(2, 10)).toString() + " KB";
    } else {
        return Math.round(size / Math.pow(2, 20)).toString() + " MB";
    }
}

export function truncateFileName(fileName: string, maxLength: number = 127): string {
    if (fileName.length <= maxLength) {
        return fileName;
    }

    const lastDot = fileName.lastIndexOf(".");
    if (lastDot <= 0) {
        return fileName.slice(0, maxLength);
    }

    const extension = fileName.slice(lastDot);
    const baseName = fileName.slice(0, lastDot);
    const maxBaseLength = maxLength - extension.length;

    if (maxBaseLength <= 0) {
        return extension.slice(0, maxLength);
    }

    return baseName.slice(0, maxBaseLength) + extension;
}

export function updateParagraphStyles(html: string): string {
    // Parse the HTML
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    // Find all <p> tags
    const paragraphs = doc.querySelectorAll("p");

    paragraphs.forEach(p => {
        const existingStyle = p.getAttribute("style") || "";

        // Split styles into key/value pairs
        const styleMap = new Map<string, string>();

        existingStyle
            .split(";")
            .map(s => s.trim())
            .filter(Boolean)
            .forEach(style => {
                const [key, ...valueParts] = style.split(":");
                if (!key || valueParts.length === 0) return;

                styleMap.set(key.trim().toLowerCase(), valueParts.join(":").trim());
            });

        // No space above or below a paragraph; the left and right margins and padding stay, as they carry the
        // indent button's padding-left and the indent of quoted Outlook lists.
        ["margin", "padding"].forEach(box => {
            const shorthand = styleMap.get(box);
            if (shorthand !== undefined) {
                styleMap.delete(box);
                const [, right, , left] = ExpandBoxShorthand(shorthand);
                if (!styleMap.has(`${box}-right`)) styleMap.set(`${box}-right`, right);
                if (!styleMap.has(`${box}-left`)) styleMap.set(`${box}-left`, left);
            }

            styleMap.set(`${box}-top`, "0px");
            styleMap.set(`${box}-bottom`, "0px");
        });

        // Rebuild style string
        const newStyle = Array.from(styleMap.entries())
            .map(([key, value]) => `${key}:${value}`)
            .join("; ");

        p.setAttribute("style", newStyle);
    });

    return doc.body.innerHTML;
}

/** Top, right, bottom and left of a CSS margin or padding shorthand ("0 0 0 36pt", "5px 10px", …). */
function ExpandBoxShorthand(value: string): [string, string, string, string] {
    const [top = "0px", right = top, bottom = top, left = right] = value.trim().split(/\s+/);
    return [top, right, bottom, left];
}
